import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';

interface HotelMarketInsightTooltipsRateindexIconsSignature {
  Args: {
    rateindex: unknown;
  };
}

const HotelMarketInsightTooltipsRateindexIcons = <template>
  {{! @glint-nocheck: not typesafe yet }}
  {{#if @rateindex.formattedCancellableIcon}}
    <PrismIcon
      @name={{@rateindex.formattedCancellableIcon}}
      @size="extra-small"
    />
  {{/if}}
  {{#if @rateindex.formattedMealtypeIncludedIcon}}
    <PrismIcon
      @name={{@rateindex.formattedMealtypeIncludedIcon}}
      @size="extra-small"
    />
  {{/if}}
</template> satisfies TOC<HotelMarketInsightTooltipsRateindexIconsSignature>;

export default HotelMarketInsightTooltipsRateindexIcons;
